import { render } from "./VendorsSearch.vue?vue&type=template&id=a324bfe6&scoped=true&lang=pug"
import script from "./VendorsSearch.vue?vue&type=script&lang=ts"
export * from "./VendorsSearch.vue?vue&type=script&lang=ts"

import "./VendorsSearch.vue?vue&type=style&index=0&id=a324bfe6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a324bfe6"

export default script